module.exports = __webpack_public_path__ + "img/web3_1.3aefc227.jpg";